import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { SUPPORTED_LANGUAGES } from '@/config/app.config';
import merge from 'lodash.merge';

Vue.use(VueI18n);

function loadLocaleInfo() {
  const locales = require.context(
    '../locale',
    false,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const localeMessages: VueI18n.LocaleMessages = {};

  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];

      // ignore locale files not yet in the supported language list.
      if (SUPPORTED_LANGUAGES.includes(locale)) {
        localeMessages[locale] = locales(key);
      }
    }
  });

  return { id: locales.id, localeMessages };
}

const localeInfo = loadLocaleInfo();

const options: VueI18n.I18nOptions = {
  messages: localeInfo.localeMessages, // set locale messages
  silentTranslationWarn: true // hide console warnings of failed localization
};

const i18n = new VueI18n(options);

if (module.hot) {
  module.hot.accept(localeInfo.id as string, () => {
    const messages = loadLocaleInfo();
    Object.keys(messages).forEach(locale => {
      i18n.setLocaleMessage(locale, messages.localeMessages[locale]);
    });
  });
}

/**
 * Load a merged version of common and Su specific JSON Locale values
 *
 * @param lang The selected language for the given suName
 * @param suName The screening unit name
 */
export async function loadLocaleByLanguageAndSuNameAsync(lang: string, suName: string) {
  const [suModule, baseModule] = await Promise.all([
    import(`@/locale/su/${suName}/${lang}.json`),
    import(`@/locale/${lang}.json`)
  ]);

  const merged = merge({}, baseModule.default, suModule.default); // deep merge without mutating base
  i18n.setLocaleMessage(lang, merged);
}

export default i18n;
